import { click } from './tracking';

/**
 * Bind the click event on the given element
 *
 * @param {HTMLElement|Element} element Element to bind click event to
 */
export default function bindClickEvent(element) {
  // get tracking key and other infos
  const trackingKey = element.getAttribute('data-tracking');
  const href = element.getAttribute(element.nodeName === 'A' ? 'href' : 'data-href');
  const slug = href.split('/').pop();
  const type = element.getAttribute('type');

  const rateCode = element.getAttribute('data-rate-code') ?? '';
  // send click tracking
  if (trackingKey === 'e') {
    const searchCode = element.getAttribute('search-code');
    const externalCode = element.getAttribute('external-code');
    const clickCode = element.getAttribute('click-code');
    click(trackingKey, { searchCode, externalCode, clickCode, rateCode }).then( function () {
      redirect(element, href);
    });
  } else if (trackingKey === 'rc' || trackingKey === 'cc' || trackingKey === 'p' || trackingKey === 'r' || trackingKey === 'rr') {
    const clickCode = element.getAttribute('data-click-code');
    click(trackingKey, { clickCode, rateCode }).then( function () {
      redirect(element, href);
    });
  } else if (type && type === 'userQuestion') click(trackingKey, { slug }, 'userQuestion');
  else click(trackingKey, { slug, rateCode }).then( function () {
      redirect(element, href);
    });

  if (element.nodeName === 'A') {
    // redirect after the click
    if (element.target === '_blank') window.open(href);
    else window.location.href = href;
  }
}

function redirect(element, href) {
  if (element.nodeName === 'A') {
    // redirect after the click
    if (element.target === '_blank') window.open(href);
    else window.location.href = href;
  }
}
